export class VerifyIdSuccess {
  static readonly type = '[Username API] Verify ID Success';
  constructor(public userInfo: any) {}
}

export class VerifyIdFailure {
  static readonly type = '[Username API] Verify ID Failure';
  constructor(public error?: any) {}
}
